import { useMemo } from 'react';

interface ProtocolProgress {
  currentDay: number;
  daysLeft: number;
  progressPercent: number;
  isCompleted: boolean;
  currentWeek: number;
}

export const useProtocolProgress = (
  startDate: string | null,
  totalDays: number = 21
): ProtocolProgress | null => {
  
  return useMemo(() => {
    if (!startDate) return null;

    // Parse the start date and reset to midnight
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    // Get today's date at midnight
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Calculate elapsed days
    const diffTime = today.getTime() - start.getTime();
    const elapsedDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    // Current day starts at 1 (day of generation is day 1)
    const currentDay = Math.min(Math.max(elapsedDays + 1, 1), totalDays);
    
    // Calculate other values
    const daysLeft = Math.max(totalDays - currentDay, 0);
    const progressPercent = Math.min(Math.round((currentDay / totalDays) * 100), 100);
    const isCompleted = currentDay >= totalDays;
    const currentWeek = Math.ceil(currentDay / 7);

    return {
      currentDay,
      daysLeft,
      progressPercent,
      isCompleted,
      currentWeek
    };
  }, [startDate, totalDays]);
};
